module.exports = __webpack_public_path__ + "static/dashboard-bbb3143ae1801d0f30350e79fbcde666.png";